export default __webpack_public_path__ + "static/media/Success.8cdcc75f.mp3";